import React from "react";
import "./sequenceplaces.css";

class SequencePlaces extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            real_place:
                props.real_place || "",

            fictional_place:
                props.fictional_place || "",

            real_epoch:
                props.real_epoch || "",

            fictional_epoch:
                props.fictional_epoch || ""
        };

        this.handleChange =
            this.handleChange.bind(this);
    }


    componentDidUpdate(prevProps)
    {
        if (
            prevProps.real_place !== this.props.real_place ||
            prevProps.fictional_place !== this.props.fictional_place ||
            prevProps.real_epoch !== this.props.real_epoch ||
            prevProps.fictional_epoch !== this.props.fictional_epoch
        )
        {
            this.setState({
                real_place:
                    this.props.real_place || "",

                fictional_place:
                    this.props.fictional_place || "",

                real_epoch:
                    this.props.real_epoch || "",

                fictional_epoch:
                    this.props.fictional_epoch || ""
            });
        }
    }


    handleChange(event)
    {
        const name = event.target.name;
        const value = event.target.value;

        this.setState({
            [name]: value
        });

        if (this.props.onChange)
        {
            this.props.onChange({
                ...this.state,
                [name]: value
            });
        }
    }


    renderField(name, label)
    {
        return (
            <div className="sequence-place-field">

                <div className="sequence-place-label">
                    {label}
                </div>

                <input
                    type="text"
                    name={name}
                    value={this.state[name]}
                    onKeyDown={e=> e.stopPropagation()}
                    onChange={this.handleChange}
                />

            </div>
        );
    }


    render()
    {
        return (
            <div className="sequence-places">

                <div className="sequence-place-column">

                    {this.renderField(
                        "real_place",
                        "Lieu (réel)"
                    )}

                    {this.renderField(
                        "real_epoch",
                        "Epoque (réelle)"
                    )}

                </div>


                <div className="sequence-place-column">

                    {this.renderField(
                        "fictional_place",
                        "Lieu (fictionnel)"
                    )}

                    {this.renderField(
                        "fictional_epoch",
                        "Epoque (fictionnelle)"
                    )}

                </div>

            </div>
        );
    }
}


export default SequencePlaces;